export default "__VITE_ASSET__f9d50fb9__"